import { CommandDescriptor } from "./types";

export class CommandRegistry {
  private commands = new Map<string, CommandDescriptor>();

  register(command: CommandDescriptor) {
    this.commands.set(command.id, command);
    return () => this.unregister(command.id);
  }

  unregister(commandId: string) {
    this.commands.delete(commandId);
  }

  get(commandId: string) {
    return this.commands.get(commandId);
  }

  list() {
    return Array.from(this.commands.values());
  }
}
